module.exports = __webpack_public_path__ + "static/media/spinner-opacity.899cc688.gif";